export default "__VITE_ASSET__8818c73a__"